<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <label class="generalLabel" for="email">Email</label>
    <input type="text" class="form-control generalInput" id="email" v-model.trim.lazy="v$.email.$model"
      autocomplete="off">
    <div v-if="v$.email.$dirty">
      <small class="form-text text-danger" v-if="v$.email.required.$invalid">Campo requerido</small>
      <small class="form-text text-danger" v-if="v$.email.email.$invalid && !v$.email.required.$invalid">El
        formato no es correcto</small>
    </div>
    <button class="btn btn-primary generalPrimaryButton float-right mt-5" data-dismiss="modal" aria-label="Close"
      :disabled="v$.$invalid" @click="modifiedData()">Confirmar</button>
  </Modal>
</template>

<script>

import Modal from '../../Shared/Modal.vue';
import useVuelidate from '@vuelidate/core';
import { email, required } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: 'EditEmail',
  setup() {
    return { v$: useVuelidate() }
  },
  props: [
    'id',
    'modalTitle',
    'class',
    'list'
  ],
  data() {
    return {
      classes: this.class,
      email: '',
    }
  },
  validations() {
    return {
      email: {
        required,
        email
      },
    }
  },
  components: {
    Modal,
  },
  methods: {
    modifiedData() {
      let bodyToSend = {
        legalIdentifier: this.list.legalIdentifier,
        mobile: this.list.mobile,
        email: this.email,
        street: this.list.street,
        number: this.list.number,
        postalCode: this.list.postalCode,
        city: this.list.city,
        province: this.list.province,
        surname: this.surname
      }
      axios.patch(`/customer/blacklist-update-email/${this.list.email}`, bodyToSend)
        .then(() => {
          axios.get(`/customer/blacklist-email/${bodyToSend.email}`)
          .then((response) => {
            this.$emit("refreshRegisterList", response.data);
          });
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
